<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-6 mr-auto">
        <h3>Subscription Performance Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by From</u></label>
        <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by To</u></label>
        <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="To">
      </div>
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
          <option value=null selected>- select operator-</option>
          <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
        </select>
    </div>
    <div class="col">
      <label for=""><u>Filter by Short Code</u></label>
      <ng-select [items]="shortCodeList" (clear)="onClear()"  placeholder="Select short code" [(ngModel)]="filterable.shortCode"  class="form-control"  (ngModelChange)="changeShortCode($event)">
      </ng-select>
    </div>
      <div class="col">
        <label for=""><u>Filter by Date Type</u></label>
        <select [(ngModel)]="filterable.dateType" class="form-control" placeholder="Date Type">
          <option *ngFor="let date of dateTypeList | keyvalue" [value]="date.key">{{date.value}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Report Type</u></label>
        <select [(ngModel)]="filterable.reportType" class="form-control" placeholder="Report Type">
          <option *ngFor="let report of reportTypeList | keyvalue" [value]="report.value">{{report.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Data Flag</u></label>
        <select [(ngModel)]="filterable.realtime" class="form-control" placeholder="realtime">
          <option *ngFor="let rtf of realtimeFlags | keyvalue" [ngValue]="rtf.value">{{rtf.key}}</option>
        </select>
      </div>

    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}<span  *ngIf="resultName != ''"  > - <span class="font-weight-bold font-italic text-danger">{{resultName}}</span> </span>

  </div>
  <div class="col ml-auto text-right align-self-end">
    <div class="form-check form-check-inline align-middle">
      <input class="form-check-input text-dark" type="checkbox" id="checkbox" [(ngModel)]="hiddenFlag">
      <label class="form-check-label text-dark font-weight-bold" for="checkbox">Hidden Zero</label>
    </div>
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
    <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>

  </div>
</div>
<div class="table-responsive">
  <table id="subList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
    <thead>
      <tr>
        <th class="align-middle" rowspan="2" *ngIf="requestParams['reportType'] == 1">Client</th>
        <th class="align-middle" rowspan="2" *ngIf="requestParams['reportType'] == 2">ShortCode</th>
        <th class="align-middle" rowspan="2" *ngIf="requestParams['reportType'] == 3">Spider Account</th>
        <th class="align-middle" rowspan="2">Operator</th>
        <th [attr.colspan]="subsReportLength">Reports</th>
      </tr>
      <tr>
        <th *ngFor="let rep of reports">{{rep.day}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="loading">
        <td colspan="7">
          <div class="loader">Loading...</div>
        </td>
      </tr>
      <tr *ngIf="emptyResult">
        <td colspan="7">
          <div class="alert alert-warning">Empty Result...</div>
        </td>
      </tr>
      <tr *ngFor="let sub of subscriptions; index as i; ">
        <ng-container *ngIf="isDisplay(sub.allZero)">
          <td *ngIf="requestParams['reportType'] == 1">
            <a href="javascript:return null;" target="_blank" [routerLink]="['/dashboard/subscription-performance-detail',{client:sub.client, source: requestParams['source'], country: requestParams['country'], operator: sub.operator, from: requestParams['from'], to: requestParams['to'], dateType: requestParams['dateType'] , realtime: requestParams['realtime']}]">
              {{sub.client}}
            </a>
          </td>
          <td *ngIf="requestParams['reportType'] == 2">
            <a href="javascript:return null;" target="_blank"  [routerLink]="['/dashboard/subscription-performance-detail',{source: requestParams['source'], country: requestParams['country'], operator: sub.operator,shortCode: sub.shortCode, from: requestParams['from'], to: requestParams['to'], dateType: requestParams['dateType'] , realtime: requestParams['realtime']}]" >
              {{sub.shortCode}}
            </a>
          </td>
          <td *ngIf="requestParams['reportType'] == 3">
            <a href="javascript:return null;" target="_blank"  [routerLink]="['/dashboard/subscription-performance-detail',{spiderAccount: sub.spiderAccount, source: requestParams['source'], country: requestParams['country'], operator: sub.operator, from: requestParams['from'], to: requestParams['to'], dateType: requestParams['dateType'] , realtime: requestParams['realtime']}]" >
              {{sub.spiderAccount}}
            </a>
          </td>
          <td>{{sub.operator}}</td>
          <td align="right" *ngFor="let rep of sub.reports">{{rep.count}}</td>
        </ng-container>
      </tr>
    </tbody>
    <tfoot>

    </tfoot>
  </table>
</div>

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>

